import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';

import { AttachmentsNoteComponent } from '@files/attachments-note/attachments-note/attachments-note.component';
import { PermissionsComponent } from '@files/permissions/permissions.component';

export const Ng1Files = angular
  .module('ng1module.files', [])
  .directive('appPermissions', downgradeComponent({ component: PermissionsComponent }) as angular.IDirectiveFactory)
  .directive(
    'cipoAttachmentsNote',
    downgradeComponent({ component: AttachmentsNoteComponent }) as angular.IDirectiveFactory,
  ).name;
